import useAuthStore from '@store/authStore'
import storageUtil from '@zet/utils/storage'

export const useLogout = () => {
  const { setIsAuthenticated } = useAuthStore((state) => state)

  const logout = async () => {
    storageUtil.mmkvStorage.clearAll()
    setIsAuthenticated(false)
  }

  return { logout }
}
